import Config from '@/config';

export const PROXY_URL_EXCLUDE = [
  Config.H5_SERVICE.URL,
  Config.WMP.BUSINESS_URL,
  Config.AIRAISA_STATIC,
  Config.AIRAISA_SCH,
  Config.BFF_SERVICE.URL,
];
